import React, { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import api from "@/lib/api";
import { Logo } from "@/components/domain/Bits";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Lock, Loader2, ArrowLeft, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("Mínimo 6 caracteres"); return; }
    if (password !== confirm) { toast.error("Las contraseñas no coinciden"); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      toast.success("Contraseña actualizada");
      setTimeout(() => nav("/login"), 1800);
    } catch (err) {
      toast.error(err.response?.data?.detail || "No se pudo restablecer");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-[#0A0A0B] px-6">
      <div className="w-full max-w-sm rounded-2xl border border-slate-800 bg-[#111014] p-8">
        <div className="mb-6"><Logo dark /></div>
        {!token ? (
          <p className="text-sm text-slate-400">Enlace inválido. Solicita uno nuevo desde <Link to="/login" className="text-brand">Iniciar sesión</Link>.</p>
        ) : done ? (
          <div className="text-center text-slate-200"><CheckCircle2 className="mx-auto h-12 w-12 text-emerald-400" /><p className="mt-3 text-sm">Tu contraseña fue actualizada. Redirigiendo al inicio de sesión…</p></div>
        ) : (
          <>
            <h1 className="font-display text-xl font-bold text-white">Crea una nueva contraseña</h1>
            <p className="mt-1 text-sm text-slate-400">Ingresa tu nueva contraseña para tu cuenta.</p>
            <form onSubmit={submit} className="mt-6 space-y-3" data-testid="reset-form">
              <div className="relative"><Lock className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-500" /><Input type="password" placeholder="Nueva contraseña" value={password} onChange={(e) => setPassword(e.target.value)} className="pl-10 bg-white/5 border-slate-700 text-white placeholder:text-slate-500 focus-visible:ring-brand" data-testid="reset-password" /></div>
              <div className="relative"><Lock className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-500" /><Input type="password" placeholder="Confirmar contraseña" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="pl-10 bg-white/5 border-slate-700 text-white placeholder:text-slate-500 focus-visible:ring-brand" data-testid="reset-confirm" /></div>
              <Button type="submit" disabled={busy} className="w-full rounded-full bg-brand hover:bg-brand-hover" data-testid="reset-submit">{busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null}Guardar contraseña</Button>
            </form>
            <Link to="/login" className="mt-4 inline-flex items-center gap-1.5 text-xs text-slate-400 hover:text-white"><ArrowLeft className="h-3.5 w-3.5" />Volver</Link>
          </>
        )}
      </div>
    </div>
  );
}
